export default {"src":"/pro/_next/static/media/brotrade-chain-env-switcher-icon.ff8698ee.svg","height":141,"width":141,"blurWidth":0,"blurHeight":0};